"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumIdentifierFromTitle = void 0;
var codegen_1 = require("./codegen");
var utils_1 = require("../utils");
var lodash_deburr_1 = __importDefault(require("lodash.deburr"));
var lodash_camelcase_1 = __importDefault(require("lodash.camelcase"));
var lodash_snakecase_1 = __importDefault(require("lodash.snakecase"));
var startsWithDigitRegex = /^\d/;
var periodRegex = /\./g;
var enumIdentifierFromTitle = function (t) {
    var nt = lodash_deburr_1.default(t);
    nt = utils_1.numToWord(nt);
    nt = lodash_camelcase_1.default(nt);
    nt = utils_1.capitalize(nt);
    return nt;
};
exports.enumIdentifierFromTitle = enumIdentifierFromTitle;
var Rust = /** @class */ (function (_super) {
    __extends(Rust, _super);
    function Rust() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Rust.prototype.getCodePrefix = function () {
        return [
            "extern crate serde;",
            "extern crate serde_json;",
            "extern crate derive_builder;"
        ].join("\n");
    };
    Rust.prototype.getSafeTitle = function (title) {
        var n = _super.prototype.getSafeTitle.call(this, title);
        // Remove all non-alphabetic characters before the first char
        return n.replace(/^[^A-Z]+/m, "");
    };
    Rust.prototype.generate = function (s, ir) {
        return [
            ir.documentationComment,
            ir.macros,
            ir.macros ? "\n" : "",
            "pub " + ir.prefix + " " + this.getSafeTitle(s.title),
            ir.prefix === "type" ? " = " : " ",
            ir.typing,
            ir.prefix === "type" ? ";" : "",
        ].join("");
    };
    Rust.prototype.handleBoolean = function (s) {
        return { prefix: "type", typing: "bool", documentationComment: this.buildDocs(s) };
    };
    Rust.prototype.handleNull = function (s) {
        return {
            prefix: "type",
            typing: "serde_json::Value",
            documentationComment: this.buildDocs(s),
            imports: [
                "use serde::{Serialize, Deserialize};",
                "use std::collections::HashMap;",
            ]
        };
    };
    Rust.prototype.handleNumber = function (s) {
        return { prefix: "type", typing: "f64", documentationComment: this.buildDocs(s) };
    };
    Rust.prototype.handleInteger = function (s) {
        return { prefix: "type", typing: "i64", documentationComment: this.buildDocs(s) };
    };
    /**
     * Currently I dont know of a good way to handle this with rust.
     */
    Rust.prototype.handleNumericalEnum = function (s) {
        if (s.type === "integer") {
            return this.handleInteger(s);
        }
        return this.handleNumber(s);
    };
    Rust.prototype.handleString = function (s) {
        if (s.const) {
            var copy = __assign({}, s);
            copy.enum = [s.const];
            delete copy.const;
            return this.handleStringEnum(copy);
        }
        return { documentationComment: this.buildDocs(s), prefix: "type", typing: "String" };
    };
    Rust.prototype.handleStringEnum = function (s) {
        var sEnum = s.enum;
        var enumFields = sEnum
            .filter(function (enumField) { return typeof enumField === "string"; })
            .map(function (enumField) {
            return [
                "    #[serde(rename = \"" + enumField + "\")]",
                "    " + exports.enumIdentifierFromTitle(enumField) + ",",
            ].join("\n");
        });
        return {
            macros: "#[derive(Serialize, Deserialize, Clone, Debug, Eq, PartialEq)]",
            prefix: "enum",
            typing: __spreadArray(__spreadArray(["{"], enumFields), ["}"]).join("\n"),
            documentationComment: this.buildDocs(s),
            imports: [
                "use serde::{Serialize, Deserialize};",
                "use derive_builder::Builder;",
            ]
        };
    };
    Rust.prototype.handleOrderedArray = function (s) {
        return {
            prefix: "type",
            typing: "(" + this.getJoinedSafeTitles(s.items) + ")",
            documentationComment: this.buildDocs(s),
        };
    };
    Rust.prototype.handleUnorderedArray = function (s) {
        return {
            prefix: "type",
            typing: "Vec<" + this.getSafeTitle(this.refToTitle(s.items)) + ">",
            documentationComment: this.buildDocs(s),
        };
    };
    Rust.prototype.handleUntypedArray = function (s) {
        return {
            prefix: "type",
            typing: "Vec<serde_json::Value>",
            documentationComment: this.buildDocs(s),
        };
    };
    Rust.prototype.handleObject = function (s) {
        var _this = this;
        var sProps = s.properties;
        var propertyTypings = Object.keys(sProps).reduce(function (typings, key) {
            var propSchema = sProps[key];
            var isRequired = false;
            if (s.required) {
                isRequired = s.required.indexOf(key) !== -1;
            }
            var typeName = _this.getSafeTitle(_this.refToTitle(propSchema));
            if (propSchema !== false && propSchema !== true && propSchema.isCycle) {
                typeName = "Box<" + typeName + ">";
            }
            if (!isRequired) {
                typeName = "Option<" + typeName + ">";
            }
            var serdeRename = false;
            var structFieldName = key;
            var unallowedSymbolPrefixes = ["$", "@"];
            if (unallowedSymbolPrefixes.reduce(function (m, s) { return m || key.startsWith(s); }, false)) {
                serdeRename = true;
                structFieldName = key.substring(1);
            }
            var reservedWords = ["if", "else", "type", "ref", "const", "enum", "default"];
            if (reservedWords.indexOf(structFieldName) !== -1) {
                serdeRename = true;
                structFieldName = "_" + structFieldName;
            }
            else if (lodash_snakecase_1.default(key) !== key) {
                serdeRename = true;
                structFieldName = lodash_snakecase_1.default(key);
            }
            var macro = "";
            if (serdeRename) {
                if (isRequired) {
                    macro = "#[serde(rename = \"" + key + "\")]";
                }
                else {
                    macro = "#[serde(rename = \"" + key + "\", skip_serializing_if = \"Option::is_none\")]";
                }
            }
            else {
                if (!isRequired) {
                    macro = "#[serde(skip_serializing_if = \"Option::is_none\")]";
                }
            }
            return __spreadArray(__spreadArray([], typings), [
                [
                    macro ? "    " + macro + "\n" : "",
                    "    pub " + structFieldName + ": " + typeName + ",",
                ].join(""),
            ]);
        }, []);
        if (s.additionalProperties) {
            var addPropS = s.additionalProperties;
            var typeName = this.getSafeTitle(this.refToTitle(addPropS));
            if (addPropS !== true && addPropS.isCycle) {
                typeName = "Box<" + typeName + ">";
            }
            propertyTypings.push([
                "#[serde(flatten)]\n",
                "pub additional_properties: " + typeName + ","
            ].map(function (s) { return "    " + s; }).join(""));
        }
        return {
            prefix: "struct",
            typing: __spreadArray(__spreadArray(["{"], propertyTypings), ["}"]).join("\n"),
            macros: [
                "#[derive(Serialize, Deserialize, Clone, Debug, PartialEq, Builder, Default)]",
                "#[builder(setter(strip_option), default)]",
                "#[serde(default)]"
            ].join("\n"),
            documentationComment: this.buildDocs(s),
            imports: [
                "use serde::{Serialize, Deserialize};",
                "use derive_builder::Builder;",
            ]
        };
    };
    Rust.prototype.handleUntypedObject = function (s) {
        var typeName = "serde_json::Value";
        if (s.additionalProperties) {
            // const typeName = this.getSafeTitle(this.refToTitle(s.additionalProperties));
            // const propertyTypings = [
            //   "#[serde(flatten)]",
            //   `pub additional_properties: Option<${typeName}>`
            // ].map((s) => `    ${s}`);
            // return {
            //   prefix: "struct",
            //   typing: ["{", ...propertyTypings, "}"].join("\n"),
            //   macros: [
            //     "#[derive(Serialize, Deserialize, Clone, Debug, PartialEq, Builder, Default)]",
            //     "#[builder(setter(strip_option), default)]",
            //     "#[serde(default)]"
            //   ].join("\n"),
            //   documentationComment: this.buildDocs(s),
            //   imports: [
            //     "use serde::{Serialize, Deserialize};",
            //     "use derive_builder::Builder;",
            //   ]
            // };
            typeName = this.getSafeTitle(this.refToTitle(s.additionalProperties));
        }
        return {
            prefix: "type",
            typing: "HashMap<String, " + typeName + ">",
            documentationComment: this.buildDocs(s),
            imports: [
                "use std::collections::HashMap;",
            ]
        };
    };
    Rust.prototype.handleAnyOf = function (s) {
        return this.buildEnum(s.anyOf);
    };
    /**
     * I dont have a great way of doing this one either. The best I can do is call it an untyped object
     */
    Rust.prototype.handleAllOf = function (s) {
        return this.handleUntypedObject(s);
    };
    Rust.prototype.handleOneOf = function (s) {
        return this.buildEnum(s.oneOf);
    };
    Rust.prototype.handleConstantBool = function (s) {
        return {
            typing: "type " + utils_1.getTitle(s) + " = serde_json::Value;",
        };
    };
    Rust.prototype.handleUntyped = function (s) {
        return { documentationComment: this.buildDocs(s), prefix: "type", typing: "serde_json::Value" };
    };
    Rust.prototype.buildEnum = function (s) {
        var _this = this;
        var typeLines = s
            .map(function (enumItem) {
            var typeName = _this.getSafeTitle(_this.refToTitle(enumItem));
            var rhsTypeName = typeName;
            if (enumItem !== false && enumItem !== true && enumItem.isCycle) {
                rhsTypeName = "Box<" + typeName + ">";
            }
            return typeName + "(" + rhsTypeName + ")";
        })
            .map(function (l) { return "    " + l + ","; })
            .join("\n");
        return {
            macros: [
                "#[derive(Serialize, Deserialize, Clone, Debug, PartialEq)]",
                "#[serde(untagged)]"
            ].join("\n"),
            prefix: "enum",
            typing: ["{", typeLines, "}"].join("\n"),
            imports: [
                "use serde::{Serialize, Deserialize};",
            ]
        };
    };
    Rust.prototype.buildDocs = function (s) {
        var docStringLines = [];
        if (s.description) {
            docStringLines.push("/// " + s.description);
            docStringLines.push("///");
        }
        if (s.default) {
            var def = s.default;
            var defAsStr = "" + def;
            if (def instanceof Array || (typeof def === "object" && def !== null)) {
                defAsStr = JSON.stringify(def);
            }
            docStringLines.push("/// # Default");
            docStringLines.push("///");
            docStringLines.push("/// " + defAsStr);
            docStringLines.push("///");
        }
        if (s.examples) {
            s.examples.forEach(function (example) {
                docStringLines.push("/// # Example");
                docStringLines.push("///");
                docStringLines.push("/// `" + example + "`");
                docStringLines.push("///");
            });
        }
        if (docStringLines.length > 0) {
            return __spreadArray(__spreadArray([
                "/// " + this.getSafeTitle(s.title),
                "///"
            ], docStringLines), [
                "",
            ]).join("\n");
        }
    };
    return Rust;
}(codegen_1.CodeGen));
exports.default = Rust;
